module.exports = __webpack_public_path__ + "b26562e278c685355e85ea2dbe9e6197.svg";